if (!customElements.get('product-description-accordion')) {
  customElements.define(
    'product-description-accordion',
    class ProductDescriptionAccordion extends HTMLElement {
      connectedCallback() {
        this.parseDescription();
      }

      parseDescription() {
        let descriptionHTML = this.innerHTML;

        // Remove all HTML tags except within section content
        // This will help us find the tags more reliably
        const sections = {
          description: this.extractSection(descriptionHTML, 'DESCRIPTION'),
          care: this.extractSection(descriptionHTML, 'CARE'),
          composition: this.extractSection(descriptionHTML, 'COMPOSITION')
        };

        // If no sections found, show content as-is
        if (!sections.description && !sections.care && !sections.composition) {
          return; // Keep original content
        }

        // Build accordion HTML
        let accordionHTML = '<div class="product__description-accordion">';

        if (sections.description) {
          accordionHTML += this.createAccordionItem('DETALLES DEL PRODUCTO', sections.description, true);
        }

        if (sections.care) {
          accordionHTML += this.createAccordionItem('CUIDADOS Y LAVADO', sections.care, false);
        }

        if (sections.composition) {
          accordionHTML += this.createAccordionItem('COMPOSICIÓN', sections.composition, false);
        }

        accordionHTML += '</div>';

        // Replace content with accordion
        this.innerHTML = accordionHTML;
      }

      extractSection(html, sectionName) {
        const startTag = `[${sectionName}]`;
        const endTag = `[/${sectionName}]`;

        // Create a searchable version by removing only BR and P tags but keeping content
        const searchableHTML = html
          .replace(/<br\s*\/?>/gi, '')
          .replace(/<\/?p[^>]*>/gi, '')
          .replace(/\s+/g, ' ');

        const startIndex = searchableHTML.indexOf(startTag);
        const endIndex = searchableHTML.indexOf(endTag);

        if (startIndex === -1 || endIndex === -1) {
          return null;
        }

        // Now extract from the original HTML using the positions found
        // We need to find the actual content between the tags in the original HTML
        const startTagIndex = html.indexOf(startTag);
        const endTagIndex = html.indexOf(endTag);

        if (startTagIndex === -1 || endTagIndex === -1) {
          return null;
        }

        const content = html.substring(startTagIndex + startTag.length, endTagIndex).trim();
        return content.length > 0 ? content : null;
      }

      createAccordionItem(title, content, isOpen = false) {
        const id = `accordion-${title.toLowerCase().replace(/\s+/g, '-')}-${Math.random().toString(36).substr(2, 9)}`;
        
        return `
          <div class="product__accordion accordion quick-add-hidden">
            <details id="${id}">
              <summary>
                <div class="summary__title">
                  <h3 class="accordion__title">${title}</h3>
                </div>
                <svg class="icon-caret" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 8l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </summary>
              <div class="accordion__content rte" id="accordion-content-${title.toLowerCase().replace(/\s+/g, '-')}">
                ${content}
              </div>
            </details>
          </div>
        `;
      }
    }
  );
}
